function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  
  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function setLocation(url){
  window.location.href = encodeURI(url);
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.form = this.querySelector('form');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const allDetails = (this.form) ? this.form.querySelectorAll('details') : null;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      if (allDetails) {
        allDetails.forEach((item) => {
          item.removeAttribute('open');
          item.classList.remove('menu-opening');
          item.firstElementChild.setAttribute('aria-expanded', false);
        });
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    if (!event.currentTarget.classList.contains('mobile-facets__open-wrapper')) {
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
    }
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 200) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class SortDrawer extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.button = this.querySelector('button');
    
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    this.button.addEventListener('click', this.onCloseButtonClick.bind(this));
  }

  onSummaryClick() {
    setTimeout(() => {
      this.details.classList.add('menu-opening');
      this.summary.setAttribute('aria-expanded', true);
    }, 100);
  }

  onCloseButtonClick(event) {
    event.stopImmediatePropagation();
    this.details.classList.remove('menu-opening');
    this.details.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', false);
  }
}

customElements.define('sort-drawer', SortDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return; 
    button.addEventListener('click', (event) => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) {
        modal.show(button);
        return;
      } else {
        fetch(`${this.dataset.url}`)
        .then(response => {
          if (response.ok) {
            return response.text();
          } else {
            throw new Error("Faild upload! please try it again.");
          }
        })
        .then(responseTxt => {
          document.body.insertAdjacentHTML('afterbegin', responseTxt);
          const modal = document.querySelector(this.getAttribute('data-modal'));
          if (modal) modal.show(button);
        })
        .catch(err => {
          this.errMessageBox = document.querySelector('.product-form__error-message');
          if (this.errMessageBox) {
            this.errMessageBox.innerHTML = err;
            this.errMessageBox.closest('.product-form__error-message-wrapper').style.display = 'block';
          }
        })
        .finally(() => {
          if (this.errMessageBox) {
            setTimeout(() => {
              this.errMessageBox.closest('.product-form__error-message-wrapper').style.display = '';
            }, 3000);
          }
        })
      }
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    if (this.sliderControlWrapper) this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    if (this.sliderControlWrapper) this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));

    this.slider.addEventListener('scroll', this.update.bind(this));
    if (this.prevButton) this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    if (this.nextButton) this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }
    
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (this.sliderControlButtons.length > 0) {
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    if (this.enableSliderLooping || !this.prevButton) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderItemOffset * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;
    
    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
    
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.prevButton.removeAttribute('disabled');
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.colorLable = this.querySelector('.color_options legend');
    if (this.colorLable) this.colorLable.addEventListener('click', this.openColorModal.bind(this));
    this.addEventListener('click', this.openSizeModal);
  }

  openSizeModal(event) {
    if (event.target.value == 'Custom Size') {
        this.sizeChartSwitch(event);
    }
  }

  onVariantChange(event) {
    this.sizeChartSwitch(event);
    this.changeUnit(event);
    this.updateOptions();
    this.getItemHandle();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.handle) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      return;
    }

    if (this.data && this.dataset.url == `/products/${this.handle}`) {
      this.updateInfors();
      return;
    }

    if (!this.data && this.dataset.url == `/products/${this.handle}`) {
      this.getDataFromFetch()
        .then((data) => {
          this.data = data;
          this.updateInfors();
        })
        .catch((e) => {
          console.log(e);
          this.data = null;
        });
    }
    
    if (this.dataset.url != `/products/${this.handle}`) {
      this.dataset.url = `/products/${this.handle}`;
      this.getDataFromFetch()
        .then((data) => {
          this.data = data;
          this.updateInfors(true);
        })
        .catch((e) => {
          console.log(e);
          this.data = null;
        });
    }
  }

  changeUnit(evt) {
    if (evt.target.id != 'unit_inch' && evt.target.id != 'unit_cm') return;
    const ubs = this.querySelectorAll('.unit');
    if (ubs.length > 0) {
      ubs.forEach(o => o.innerHTML = `(${evt.target.value})`);
    }
  }

  openColorModal() {
    const colorBox = document.getElementById('color_box_panel');
    colorBox.style.visibility = 'visible';
    colorBox.style.bottom = '0px';
    document.getElementById('size_mask').style.display = "block";
  }

  updateInfors(updateMedia = false) {
    this.updateMasterId();
    if (updateMedia) this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateShareUrl();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      let select = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return (select) ? select.value : fieldset.querySelector('input').value;
    });
  }

  getItemHandle() {
    let obj = this.getItemsData().find((item) => {
      return item.variants.find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    });
    this.handle = (obj) ? obj.handle : null;
  }

  updateMasterId() {
    this.currentVariant = this.data.variants.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    const preload = document.querySelector('.imagePreload');
    preload.style.display = 'block';
    preload.style.visibility = 'visible';
    const colorLabels = document.querySelectorAll('.variant_name');
    const color = this.querySelector('input[name="Color"]:checked');
    if (colorLabels.length && color) {
      const label = this.querySelector(`label[for="${color.id}"]`).dataset.color;
      colorLabels.forEach((item) => item.textContent = label);
    }
    this.updateSwatch(color);
    const swatch = document.getElementById('ProductPopup-orderSwatch');
    if (swatch && color) swatch.firstElementChild.className = `bg-sprite icon-swatch ${color.value.toLowerCase().split(' ').join('-')}`;
    const show_color = this.querySelector('.show_color');
    if (show_color && color) show_color.className = `show_color icon-swatch ${color.value.toLowerCase().split(' ').join('-')}`;
    const infoTab = document.getElementById('ProductInfo');
    let [desc, info] = this.data.description.split('<!-- split -->');
    if (infoTab) {
      infoTab.querySelector('.description').innerHTML = desc;
      infoTab.querySelector('.product-info').innerHTML = info;
    }
    
    fetch(`${this.dataset.url}?view=medias&variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const preload = html.querySelector('.imagePreload');
        const modal = document.getElementById('vimeoVideo');
        if (modal.innerHTML.trim() != '') {
          html.querySelector('[id^="GalleryThumbnails-"]').classList.add('has-video');
          const openBtns = Array.from(html.querySelectorAll('[data-modal="#PopupModal-productVideo"]'));
          openBtns.forEach(o => {
            o.classList.remove('hidden');
          });
        }
        preload.style.display = 'block';
        preload.style.visibility = 'visible';
        const domMedia = document.querySelector('.product__media-wrapper');
        const dataMedia = html.getElementById(`media_gallery`);
        const domModal = document.querySelector('[id^="ProductModal-"]');
        const dataModal = html.getElementById('product_modal');
        if (domMedia && dataMedia) domMedia.innerHTML = dataMedia.innerHTML;
        if (domModal && dataModal) {
          domModal.remove();
          document.body.append(dataModal);
        }
        const imageone = domMedia.querySelector('#By_cheng_542145');
        if (imageone) {
          let src = imageone.dataset.src;
          let srcStr = `${src}&width=246 246w, ${src}&width=493 493w, ${src}&width=600 600w, ${src}&width=713 713w, ${src}&width=823 823w, ${src}&width=990 990w, ${src}&width=1100 1100w, ${src}&width=1206 1206w, ${src}&width=1346 1346w, ${src}&width=1426 1426w, ${src}&width=1646 1646w, ${src}&width=1946 1946w`;
          imageone.src = `${src}&width=1946`;
          imageone.srcset = srcStr;
          imageone.onload = () => {
            const preload = document.querySelector('.imagePreload');
            preload.style.display = 'none';
            preload.style.visibility = 'hidden';
          };
        }
      })
      .catch(e => console.log(e.message));
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    const breadcrumb = document.querySelector('.breadcrumbs [data-product]');
    if (breadcrumb) {
      breadcrumb.href = `${this.dataset.url}?variant=${this.currentVariant.id}`;
      breadcrumb.textContent = this.currentVariant.name;
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-sticky-add-cart`);
    productForms.forEach((form) => {
      const input = form.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateSwatch(color) {
    const swatchForm = document.getElementById('swatch-form');
    if (!color || !swatchForm) return;
    const submitBtn = swatchForm.querySelector('[type="submit"]');
    let handle = `${swatchForm.dataset.url}${color.value.toLowerCase().split(' ').join('-')}`;
    submitBtn.setAttribute('disabled', true);
    fetch(`/products/${handle}/product.json`)
    .then(response => {
      if (response.ok) {
        submitBtn.removeAttribute('disabled');
        return response.json();
      } else {
        return false;
      }
    })
    .then(data => {
      if (!data) return;
      let id = data.product.variants[0].id;
      swatchForm.querySelector('input[name="id"]').value = id;
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  async getDataFromFetch() {
    let response = await fetch(`${this.dataset.url}/product.js`);
    return await response.json();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?view=price&variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`product_price`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        let c = localStorage.getItem('currency_iso_code'), sc = window.currency;
        const n = document.querySelector('currency-change');
        const o = destination.querySelectorAll('.price-item');
        if (c != sc) {
          n.reUpdate(o, sc, c);
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-sticky-add-cart`);
    if (!productForms.length) return;
    productForms.forEach(form => {
      const addButton = form.querySelector('[name="add"]');
      const addButtonText = form.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-sticky-add-cart`);
    productForms.forEach(form => {
      const addButton = form.querySelector('[name="add"]');
      const addButtonText = form.querySelector('[name="add"] > span');
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
    });
  }

  getItemsData() {
    this.itemsData = this.itemsData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.itemsData;
  }

  sizeChartSwitch(e) {
    if (e.target.name != 'Size') return;
    const sizeBox = this.querySelector('.sizechart_box');
    const customBox = this.querySelector('.custom-size-form ');
    const size_mask = document.getElementById('size_mask');
    const formId = customBox.dataset.formId;
    const content = `<button class="sz_fm-close large-up-hide" onclick="this.parentElement.style.display='none';size_mask.style.display='none'"><span class="bg-sprite icon-close"></span></button><div class="size_form top"><h3>Size Measurement</h3><div class="sz_fm-tape-link large-up-hide"><p>Need A Tape Measure? <a href="/products/babaroni-tape-measure-19793" target="_blank">Click Here.</a>.</p></div><div class="tab"><input id="unit_inch" type="radio" name="properties[Unit]" value="Inch" form="${ formId }" checked><label for="unit_inch" class="btn">Inch</label><input id="unit_cm" type="radio" name="properties[Unit]" value="CM" form="${ formId }"><label for="unit_cm" class="btn ">CM</label></div><ul class="dress_ul"><li class="bust"><label for="options_206678_text">Bust<span class="con">:</span></label><input type="number" id="options_206678_text" class="input-text product-custom-option required-entry" name="properties[Bust]" form="${ formId }" value=""><span class="unit">(Inch)</span></li><li class="waist"><label for="options_206679_text">Waist<span class="con">:</span></label><input type="number" id="options_206679_text" class="input-text product-custom-option required-entry" name="properties[Waist]" form="${ formId }" value=""><span class="unit">(Inch)</span></li><li class="hips"><label for="options_206680_text">Hips<span class="con">:</span></label><input type="number" id="options_206680_text" class="input-text product-custom-option required-entry" name="properties[Hips]" form="${ formId }" value=""><span class="unit">(Inch)</span></li><li class="hollowtofloor"><label for="options_206681_text">Hollow to Floor<span class="con">:</span></label><input type="number" id="options_206681_text" class="input-text product-custom-option required-entry" name="properties[Hollow to Floor]" form="${ formId }" value=""><span class="unit">(Inch)</span></li><li class="heightbarefoot"><label for="options_210955_text">Height (Barefoot)<span class="con">:</span></label><input type="number" id="options_210955_text" class="input-text product-custom-option required-entry" name="properties[Height]" form="${ formId }" value=""><span class="unit">(Inch)</span></li><li class="option-item extralength"><label for="select_210956">Extra Length<span class="con">:</span></label><select name="properties[Extra Length]" id="select_210956" class=" product-custom-option" form="${ formId }"><option value="">-- Seleccione --</option><option value="+0"> +0 </option><option value="+1inch/2.5cm">+1inch/2.5cm </option><option value="+2inch/5cm">+2inch/5cm </option><option value="+3inch/7.6cm">+3inch/7.6cm </option><option value="+4inch/10cm">+4inch/10cm </option><option value="+5inch/12.7cm">+5inch/12.7cm </option></select><span class="unit"> (Inch)</span><span href="javascript:void(0)" id="elfaq" class="small-hide medium-hide"><em class="bg-sprite icon-ask"></em><div id="shoe-height-note" class="text-tip"><span class="big-card"> I undersand that custom size is the final sale. My order will be custom-made with the measurements I provided. And I would be charged for all cost of any additional alterations. </span></div></span></li></ul></div><div class="size_form bottom"><div class="bot-wrap"><ul><li><div class="note-size"></div><div class="return_support_notice"><span><input type="checkbox" name="return_support_checkbox" id="return_support_checkbox" class="return_support_checkbox required-entry" value=""></span><span><label for="return_support_checkbox">I understand that custom sizing is the final sale. My order will be custom made with the measurements I provided. And I would be charged for all costs of any further alterations.</label></span></div> </li></ul></div></div><div id="custom_submit" custom="on" class="add_to_bag large-up-hide" onclick="this.parentElement.style.display='none';size_mask.style.display='none'"><span>SUBMIT</span></div>`;
    if (e.target.value == 'Custom Size') {
      sizeBox.style.display = "none";
      customBox.style.display = "block";
      if (!customBox.innerHTML.trim()) customBox.innerHTML = content;
      size_mask.style.display = "block";
      return;
    }

    sizeBox.style.display = "block";
    customBox.style.display = "none";
    size_mask.style.display = "none";
    const selectedSize = sizeBox.querySelector('tr.size_us.selected');
    const curSize = sizeBox.querySelector(`tr[data-id="${e.target.value}"]`);
    if(selectedSize) selectedSize.classList.remove('selected');
    if(curSize) curSize.classList.add('selected');
    if (e.target.name == 'properties[Unit]') {
      const sizeUnits = Array.from(this.querySelectorAll('.unit'));
      sizeUnits.forEach(item => item.textContent = `(${e.target.value})`);
    }
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          let c = localStorage.getItem('currency_iso_code'), sc = window.currency;
          const n = document.querySelector('currency-change');
          const o = recommendations.querySelectorAll('.price-item');
          if (c != sc) {
            n.reUpdate(o, sc, c);
          }

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class CurrencyChange extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      button: this.querySelector('.disclosure__button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };
    this.items = Array.from(this.querySelectorAll('a'));
    let iso_code = localStorage.getItem('currency_iso_code');
    if (!iso_code) localStorage.setItem('currency_iso_code', window.currency);
    if (iso_code && iso_code != window.currency) this.updateCur(iso_code, true);
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.items.forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
  }

  onItemClick(event) {
    let iso_code = event.currentTarget.dataset.value;
    this.updateCur(iso_code);
    this.hidePanel();
  }

  updateCur(code, load = false) {
    let iso_code = (load) ? window.currency : localStorage.getItem('currency_iso_code');
    let curItem = this.items.find(item => item.dataset.value == code);
    localStorage.setItem('currency_iso_code', code);
    this.elements.button.querySelector('.bg-sprite').className = `bg-sprite icon-${code.toLowerCase()}`;
    this.elements.button.querySelector('.localization-form__currency').innerHTML = curItem.querySelector('.localization-form__currency').innerHTML;
    const allPrics = document.querySelectorAll('.price-item');
    this.reUpdate(allPrics, iso_code, code);
  }

  openSelector() {
    this.elements.panel.toggleAttribute('hidden');
  }

  reUpdate(elems, iso_code, code) {
    let curItem = this.items.find(item => item.dataset.value == code);
    let sympol = curItem.dataset.sympol;
    let before = this.items.find(item => item.dataset.value == iso_code);
    elems.forEach(price => {
      let str = price.innerHTML;
      if (str.indexOf(before.dataset.sympol) == -1) return;
      let index = str.indexOf(before.dataset.sympol) + 1;
      let num = parseFloat(str.slice(index));
      let after = Currency.convert(num, iso_code, code);
      price.innerHTML = `${sympol + after.toFixed(2)}`;
    });
  }
}

customElements.define('currency-change', CurrencyChange);

class CardProduct extends HTMLElement {
  constructor() {
    super();
    let i = this;
    i.p = i.querySelector('.imagePreload');
    i.addEventListener('change', i.up.bind(i));
  }

  up() {
    let i = this;
    let c = i.querySelector('input[type="radio"]:checked').value;
    let t = i.gd().items.find(i => i.Color == c);
    if (!t) return;
    i.h = t.handle;
    if (i.p) {
      i.p.style.display = 'block';
      i.p.style.visibility = 'visible';
    }
    i.gj()
      .then((d) => {
        i.ut(d.product.title);
        i.ul();
        i.ui(d.product.images);
      })
      .catch(e => console.log(e.message))
  }

  ut(t) {
    let i = this;
    const h5 = i.querySelector('.card__heading a');
    const w = i.querySelector('[button-wishlist]');
    if (h5) h5.textContent = t;
    if (w) w.dataset.productHandle = i.h;
  }

  ul() {
    let i = this;
    i.querySelectorAll('a').forEach(l => l.href = `/products/${i.h}`);
  }

  ui(m) {
    let i = this;
    i.querySelectorAll('img').forEach((p, x) => {
      p.src = `${m[x].src}&width=533`;
      p.srcset = `${m[x].src}&width=533`;
      p.onload = () => {
        if (i.p) {
          i.p.style.display = 'none';
          i.p.style.visibility = 'hidden';
        }
      }
    });
  }

  async gj() {
    let i = this;
    let r = await fetch(`/products/${i.h}/product.json`);
    return await r.json();
  }

  gd() {
    let i = this;
    i.d = i.d || JSON.parse(i.querySelector('[type="application/json"]').textContent);
    return i.d;
  }
}

customElements.define('card-product', CardProduct);